<template>
  <div>
    <div class="d-flex justify-content-between align-items-center pt-50 mb-2">
      <h2 class="font-weight-bolder m-0" >
        <span @click="$router.go(-1)" >
          <b-button
              variant="white"
              class="btn-icon rounded-circle mr-50 text-danger bg-white"
              size="sm"
          >
            <feather-icon icon="ChevronLeftIcon" />
          </b-button>
        </span> Detalles cliente
      </h2>
    </div>
    <b-card>
      <!-- form -->
      <validation-observer ref="editClient">
        <b-form
            class="mt-2"
            @submit.prevent="handleSubmit"
            @keydown.enter="handleSubmit"
        >
          <b-row>
            <b-col sm="6">
              <validation-provider
                  #default="{ errors }"
                  :name="'Nombre'"
                  rules="required"
              >
                <b-form-group
                    :label="'Nombre'"
                    label-for="client-name"
                >
                  <b-form-input
                      v-model="client.name"
                      name="name"
                      :placeholder="'Nombre'"
                  />
                </b-form-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
            <b-col sm="6">
              <validation-provider
                  #default="{ errors }"
                  :name="'Alias'"
                  rules="required"
              >
                <b-form-group
                    :label="'Alias'"
                    label-for="client-alias"
                >
                  <b-form-input
                      v-model="client.alias"
                      name="name"
                      :placeholder="'Alias'"
                  />
                </b-form-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
            <b-col sm="6">
              <validation-provider
                  #default="{ errors }"
                  :name="'CIF'"
                  rules="required"
              >
                <b-form-group
                    :label="'CIF'"
                    label-for="client-cif"
                >
                  <b-form-input
                      v-model="client.cif"
                      name="reference"
                      :placeholder="'CIF'"
                  />
                </b-form-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
            <b-col sm="6">
              <validation-provider
                  #default="{ errors }"
                  :name="'Dirección'"
                  rules="required"
              >
                <b-form-group
                    :label="'Dirección'"
                    label-for="client-address"
                >
                  <b-form-input
                      v-model="client.address"
                      name="reference"
                      :placeholder="'Dirección'"
                  />
                </b-form-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
            <b-col sm="6">
              <validation-provider
                  #default="{ errors }"
                  :name="'Código postal'"
                  rules="required"
              >
                <b-form-group
                    :label="'Código postal'"
                    label-for="client-postalCode"
                >
                  <b-form-input
                      v-model="client.postalCode"
                      name="reference"
                      :placeholder="'Código postal'"
                  />
                </b-form-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
            <b-col sm="6">
              <validation-provider
                  #default="{ errors }"
                  :name="'Pais'"
                  rules="required"
              >
                <b-form-group
                    :label="'Pais'"
                    label-for="client-country"
                >
                  <b-form-input
                      v-model="client.country"
                      name="reference"
                      :placeholder="'Pais'"
                  />
                </b-form-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
            <b-col sm="6">
              <validation-provider
                  #default="{ errors }"
                  :name="'Ciudad'"
                  rules="required"
              >
                <b-form-group
                    :label="'Ciudad'"
                    label-for="client-city"
                >
                  <b-form-input
                      v-model="client.city"
                      name="reference"
                      :placeholder="'Ciudad'"
                  />
                </b-form-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
            <b-col sm="6">
              <validation-provider
                  #default="{ errors }"
                  :name="'Telefono'"
                  rules="required"
              >
                <b-form-group
                    :label="'Telefono'"
                    label-for="client-phone"
                >
                  <b-form-input
                      v-model="client.phone"
                      name="reference"
                      :placeholder="'Telefono'"
                  />
                </b-form-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
            <b-col sm="6">
              <validation-provider
                  #default="{ errors }"
                  :name="'Email'"
                  rules="email|required"
              >
                <b-form-group
                    :label="'Email'"
                    label-for="client-email"
                >
                  <b-form-input
                      v-model="client.email"
                      name="reference"
                      :placeholder="'Email'"
                  />
                </b-form-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
            <b-col sm="6">
              <b-form-group
                  :label="'Web'"
                  label-for="client-web"
              >
                <b-form-input
                    v-model="client.web"
                    name="reference"
                    :placeholder="'Web'"
                />
              </b-form-group>
            </b-col>
            <b-col sm="12">
              <b-form-group
                  :label="'Imagen'"
                  label-for="client-image"
              >
                <ImageDropzone
                    v-if="clientPrepare"
                    ref="image"
                    :files="files"
                    maxFiles="1"
                />
              </b-form-group>
            </b-col>
            <b-col cols="12" >
              <b-form-group
                  :label="'Comentarios'"
                  label-for="client-comments"
              >
                <quill-editor
                    :options="editorOption"
                    v-model="client.comments"
                />
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <h4>Datos de contacto</h4>
            </b-col>
            <b-col sm="4">
              <validation-provider
                  #default="{ errors }"
                  :name="'Persona de contacto'"
                  rules="required"
              >
                <b-form-group
                    :label="'Persona de contacto'"
                    label-for="client-contact_person"
                >
                  <b-form-input
                      v-model="client.contact_person"
                      name="reference"
                      :placeholder="'Persona de contacto'"
                  />
                </b-form-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
            <b-col sm="4">
              <validation-provider
                  #default="{ errors }"
                  :name="'Email de contacto'"
                  rules="email|required"
              >
                <b-form-group
                    :label="'Email de contacto'"
                    label-for="client-contact_person_email"
                >
                  <b-form-input
                      v-model="client.contact_person_email"
                      name="reference"
                      :placeholder="'Email de contacto'"
                  />
                </b-form-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
            <b-col sm="4">
              <validation-provider
                  #default="{ errors }"
                  :name="'Teléfono de contacto'"
                  rules="required"
              >
                <b-form-group
                    :label="'Teléfono de contacto'"
                    label-for="client-contact_person_phone"
                >
                  <b-form-input
                      v-model="client.contact_person_phone"
                      name="reference"
                      :placeholder="'Teléfono de contacto'"
                  />
                </b-form-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
            <b-col cols="12 text-right">
              <b-button
                  type="submit"
                  variant="primary"
                  class="mt-2 mr-1"
              >
                {{ 'Enviar' }}
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-card>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import {
  BButton, BForm, BFormGroup, BFormInput, BRow, BCol, BCard,
} from 'bootstrap-vue'
import { quillEditor } from 'vue-quill-editor'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, email } from '@validations'
import Ripple from 'vue-ripple-directive'
import ImageDropzone from '@/components/elements/ImageDropzone/ImageDropzone.vue'
import quillMixin from "@/mixins/quillMixin"
export default {
  components: {
    BButton,
    BForm,
    BFormGroup,
    BFormInput,
    BRow,
    BCol,
    BCard,
    ValidationProvider,
    ValidationObserver,
    quillEditor,
    ImageDropzone,
  },
  directives: {
    Ripple,
  },
  mixins: [quillMixin],
  data() {
    return {
      files: [],
      required,
      email,
      clientPrepare: false,
    }
  },
  computed: {
    ...mapGetters({
      client: 'clients/getClient',
    }),
  },
  methods: {
    ...mapActions({
      edit: 'clients/edit',
      getClient: 'clients/getClient',
    }),
    handleSubmit() {
      this.$refs.editClient.validate().then(success => {
        if (success) {
          const { id } = this.client
          const formData = this.createFormData()
          if (formData) {
            this.edit({ id, client: formData })
          }
        }
      })
    },
    setData() {
      if (this.client.image) {
        const file = {
          name: 'Image',
          url: this.client.image.path,
          urlDelete: `/clients/delete_image/${this.client.id}`,
        }
        this.files.push(file)
      }

      this.clientPrepare = true
    },
    createFormData() {
      const data = this.$refs.image.getFormData('image')

      data.append('name', this.client.name)
      data.append('alias', this.client.alias)
      data.append('cif', this.client.cif)
      data.append('address', this.client.address)
      data.append('postalCode', this.client.postalCode)
      data.append('country', this.client.country)
      data.append('city', this.client.city)
      data.append('phone', this.client.phone)
      data.append('email', this.client.email)
      data.append('web', this.client.web)
      data.append('contact_person', this.client.contact_person)
      data.append('contact_person_email', this.client.contact_person_email)
      data.append('contact_person_phone', this.client.contact_person_phone)
      data.append('comments', this.client.comments)

      return data
    },
  },
  async created() {
    await this.getClient(this.$route.params.id)
    await this.setData()
  },
}
</script>
